<template>
    <div v-if="visibleTerms.length"> 
        <div class="card" >
            <div class="card-header" :class="titleClass">
                {{ title }}
            </div>            
          <div class="card-body p-0 ">
            <ol class="list-group list-group-numbered w-100">
                <li v-for="(term, index) in visibleTerms" :key="index" class="list-group-item d-flex justify-content-between align-items-start">
                    <div class="ms-2 me-auto" v-if="!editMode">
                        {{ term }}
                        <!-- <div class="fw-bold">{{ term }}</div> -->
                    </div>          
                </li>        
            </ol>
            
          </div>
        </div>
    </div>
</template>
<script>
export default{
    props: {
        terms: {
            type: Array,
            required: true,
            default: ()=>['No Entries']
        },
        title: {
            type: String,
            default: 'List of Items'
        },
        titleClass: {
            type: String,
            default: 'bg-secondary text-white fw-bold'
        },
    },
    computed: {
        visibleTerms() {
            return (Array.isArray(this.terms) ? this.terms : [])
                .map((term) => String(term ?? '').trim())
                .filter((term) => term.length > 0);
        }
    }
}

</script>